import React from 'react';
import UnifiedPieceCard from './UnifiedPieceCard';

/**
 * Wrapper for UnifiedPieceCard specifically for the Favorites page
 * Uses parent's favorited state to sync between card and modal
 */
const FavoritePieceCard = ({ 
  item, 
  onClick, 
  onBuy, 
  onTrade, 
  onFavoriteToggle,
  isFavorited,
  solPrice,
  showBuyButton = true,
  showTradeButton = true,
  buyButtonText = "Buy now",
  tradeButtonText = "Trade"
}) => {
  const handleFavorite = async (clickedItem) => {
    // Call the parent's toggle function which manages the shared state
    if (onFavoriteToggle) {
      await onFavoriteToggle(clickedItem);
    }
  };

  return (
    <div>
      <UnifiedPieceCard
        item={item}
        onClick={onClick}
        onBuy={onBuy}
        onTrade={onTrade}
        onFavorite={handleFavorite}
        isFavorited={isFavorited}
        solPrice={solPrice}
        showBuyButton={showBuyButton}
        showTradeButton={showTradeButton}
        showFavoriteButton={true}
        buyButtonText={buyButtonText}
        tradeButtonText={tradeButtonText}
      />
    </div>
  );
};

export default FavoritePieceCard;
